// src/components/GameOver.js
import React from 'react';
import './GameOver.css';

function GameOver({ gameState, onReturnToLobby }) {
  if (!gameState) return null;

  const { self, opponent, winner_uid, is_draw } = gameState;

  const isWinner = !is_draw && winner_uid === self.uid;
  const isLoser = !is_draw && winner_uid === opponent.uid;

  return (
    <div className="game-over-overlay">
      <div className="game-over-card">
        <div className={`result-header ${isWinner ? 'winner' : isLoser ? 'loser' : 'draw'}`}>
          {is_draw && <h1>🤝 平局！</h1>}
          {isWinner && <h1>🎉 你赢了！</h1>}
          {isLoser && <h1>😔 你输了</h1>}
        </div>

        <div className="final-scores">
          <div className={`player-score ${isWinner ? 'winner-score' : ''}`}>
            <div className="score-avatar">👤</div>
            <div className="score-details">
              <h3>{self.nickname}</h3>
              <div className="score-breakdown">
                <div className="score-item">
                  <span>代币:</span>
                  <span>{self.tokens?.length || 0} 个</span>
                </div>
                <div className="score-total">
                  <span>总分:</span>
                  <span className="score-value">{self.score}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="vs-divider">VS</div>

          <div className={`player-score ${isLoser ? 'winner-score' : ''}`}>
            <div className="score-avatar">👤</div>
            <div className="score-details">
              <h3>{opponent.nickname}</h3>
              <div className="score-breakdown">
                <div className="score-item">
                  <span>代币:</span>
                  <span>{opponent.token_count} 个</span>
                </div>
                <div className="score-total">
                  <span>总分:</span>
                  <span className="score-value">{opponent.score}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button className="btn-return" onClick={onReturnToLobby}>
          返回房间大厅
        </button>
      </div>
    </div>
  );
}

export default GameOver;
